import type { ButtonHTMLAttributes, ReactNode } from 'react';

import classNames from 'classnames';

export type RedeemOrderModalButtonProps = {
  variant: 'primary' | 'secondary';
  /** `sm` matches redeem / calendar rows; `md` for the footer Continue action. */
  size?: 'sm' | 'md';
  children: ReactNode;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'type'> & { className?: string };

export function RedeemOrderModalButton({
  variant,
  size = 'sm',
  className,
  children,
  disabled,
  ...rest
}: RedeemOrderModalButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      className={classNames(
        'w-full inline-flex items-center justify-center font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 transition-opacity rounded-md font-sans',
        size === 'sm' ? 'px-3 py-2 text-sm' : 'px-4 py-2 text-base',
        variant === 'primary' &&
          'border bg-gray-900 text-white border-gray-800 hover:bg-gray-800 hover:opacity-90 focus:ring-gray-900 disabled:opacity-50',
        variant === 'secondary' && 'border border-gray-300 bg-white text-gray-800 hover:bg-gray-50',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
